import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EcomCookies } from '../../ecom-services/ecom-cookies';

@Component({
  selector: 'app-ecom-referrals',
  templateUrl: './ecom-referrals.component.html',
  styleUrls: ['./ecom-referrals.component.scss']
})
export class EcomReferralsComponent implements OnInit {

  referredList = [];

  constructor(private eComGoogleAnalytics:EComGoogleAnalytics,public router: Router, public ecomservice: EComService, private cookie: EcomCookies,
    public webstorage: EComWebStorage, public _sanitizer: DomSanitizer) { }

  ngOnInit() {
    let gTag = {
      'event':'screen_view',
      'screen_name':'my referrals'
    };
    this.eComGoogleAnalytics.customEvent(gTag);
    if(!this.webstorage.sessionSt_is_session_valid){
      this.router.navigate(['home']);
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.LoadPage();
  }

  LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.getReferredDetails();
        }
      });
    } else {
      this.getReferredDetails();
    }
  }

  getReferredDetails() {
    const input = {
      oocr_customer_dial_code: this.ecomservice.encryptWithKey(this.webstorage.localSt_user_service_request.userDialCode),
      oocr_customer_mobile: this.ecomservice.encryptWithKey(this.webstorage.localSt_user_service_request.userMobile),
      //oocr_customer_dial_code: this.ecomservice.encryptWithKey(JSON.parse(this.cookie.cookie_service_request).userDialCode),
      //oocr_customer_mobile: this.ecomservice.encryptWithKey(JSON.parse(this.cookie.cookie_service_request).userMobile),
      user_public_key: this.webstorage.localSt_olar_key
    };
    this.ecomservice.httpPost(EcomNetworkUtils.POST_REFERRED_DETAILS, input, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          this.referredList = [];
          response.listValues.forEach(element => {
            const objReferred = {
              merchantname: element.MerchantName,
              referredtoName: element.oocr_referral_name,
              referredtoContact: element.ReferredContact,
              earnedDate: element.ReferralOrderDate,
              redeemedDate: element.CustomerOrderDate
            };
            this.referredList.push(objReferred);
          });
        }
      }
    });
  }

}
